module.exports = __webpack_public_path__ + "static/media/Avenir-Roman.ffab5d93.eot";